import React, { Component } from 'react';
import { Link } from 'react-router-dom';

export default class MagazineArticleMeta extends Component {
	getCatLink( parent_child_cats ) {
		let link = `/category/${parent_child_cats.parent.slug}/`;
		if ( parent_child_cats.parent.term_id !== parent_child_cats.child.term_id ) {
			link += `${parent_child_cats.child.slug}/`;
		}
		return link;
	}

	maybeReturnDark( ind ) {
		return (3 === ind
		       ) ? '-dark' : '';
	}

	maybeReturnDate( post ) {
		if ( post.is_sticky ) {
			return 'Pinned';
		} else if ( 'undefined' !== typeof post.parent_child_cats && post.parent_child_cats.child.name.toLowerCase() === 'infohub' ) {
			return '';
		} else if ( post.hide_date_tag_list ) {
			return '';
		} else {
			return post.formatted_date
		}
	}

	maybeReturnCategory( post ){
		if ( post.hide_category_tag_list ) {
			return '';
		} else if ( 'undefined' === typeof post.parent_child_cats || 'undefined' === typeof post.parent_child_cats.parent ) {
			return '';
		}

		return(
			<Link to={ this.getCatLink( post.parent_child_cats ) } dangerouslySetInnerHTML={ { __html: post.parent_child_cats.child.name } } />
		)
	}

	maybeReturnCategoryIcon( post ) {
		if ( 'undefined' === typeof post.parent_child_cats ) {
			return '';
		}

		return(
			<Link to={ `/category/${post.parent_child_cats.parent.slug}/` } className="category-icon-link">
				<span className="sr-only" dangerouslySetInnerHTML={ { __html: post.parent_child_cats.parent.name } } />
				<span className={ `category-icon category-${post.parent_child_cats.parent.slug}${this.maybeReturnDark( this.props.ind )}` } aria-hidden="true"></span>

			</Link>
		)
	}

	render() {
		const post = this.props.post;

		return (<div className="entry-meta">
				{ this.maybeReturnCategory(post) }
				{ this.maybeReturnDate(post) }
				{ this.maybeReturnCategoryIcon(post) }
			</div>
		);
	}
}